// extracted by mini-css-extract-plugin
export var compactFilters = "_ck-4";
export var detailImage = "_ck-1";
export var dropdownContainer = "_ck-2";
export var imageContainer = "_ck-0";
export var selectedCard = "_ck-3";